import { useMutation, useQueryClient } from 'react-query'
import { useWallet } from '~/lib/useWallet'
import { getVotingEscrowContract } from '~/contracts/getVotingEscrowContract'
import { BigNumber } from 'ethers'
import { DateTime } from 'luxon'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useVESISParams } from '~/hooks/useVESISParams'

export function useCreateLock(value: BigNumber | undefined, duration: number) {
	const { config } = useVESISParams()

	const { web3, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation(
		async () => {
			if (!value || !duration) {
				return
			}

			const contract = getVotingEscrowContract(config, web3).connect(
				web3.getSigner(account)
			)

			const unlockTime = DateTime.now()
				.plus({ weeks: duration })
				.toUnixInteger()

			const tx = await contract.create_lock(
				value.toString(),
				unlockTime.toString()
			)

			await tx.wait()
		},
		{
			onSuccess() {
				queryClient.resetQueries(
					sisTokenKeys.balance(config.chain.id, account)
				)
				queryClient.resetQueries(['sis-lock'])
			},
		}
	)
}
